/**
 * The Agentic Development Kit module.
 *
 * Reserved for a future capability, with one screen built now: the guide to continuing
 * development in this repository. It exists as a real module rather than a page bolted
 * onto the tracker, because that is what proves the platform's extension point works —
 * two independently registered modules, neither importing the other.
 *
 * It is behind the `adkModule` flag and available to everyone who can sign in. An internal
 * guide to the delivery process is not privileged information, and restricting it would
 * mean the person most likely to need it is the person who cannot open it.
 */

import { lazy } from 'react'

import { PATHS } from '../../platform/routing/paths'
import type { ModuleDefinition } from '../../platform/modules/registry'

const AgenticDeliveryHelperScreen = lazy(
  () => import('./screens/AgenticDeliveryHelperScreen'),
)

export const agenticDevKitModule: ModuleDefinition = {
  id: 'agentic-dev-kit',
  title: 'Agentic Development Kit',
  featureFlag: 'adkModule',
  nav: {
    group: {
      id: 'adk',
      label: 'Development kit',
      iconName: 'wk-icon-code',
    },
    items: [
      {
        id: 'agentic-delivery',
        label: 'Agentic delivery',
        to: PATHS.agenticDelivery,
        iconName: 'wk-icon-flow-chart',
      },
    ],
  },
  routes: [
    { path: PATHS.agenticDelivery, Component: AgenticDeliveryHelperScreen },
  ],
}
